import { render, staticRenderFns } from "./FCImage.vue?vue&type=template&id=1d4b80cf&scoped=true&"
import script from "./FCImage.vue?vue&type=script&lang=ts&"
export * from "./FCImage.vue?vue&type=script&lang=ts&"
import style0 from "./FCImage.vue?vue&type=style&index=0&id=1d4b80cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4b80cf",
  null
  
)

export default component.exports